export { default as WORDS } from "./default";
export { default as CUSTOM_WORDS } from "./custom";

export const LANGUAGES = {
  english: 0,
  spanish: 1
};
